import $ from "jquery";
import React, { useEffect, useState, useMemo } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { ContactProfileHeaderFragmentParameter } from "@/app/pages/contactDirectory/interface";
import { dnbComLog, isNotUndefined, LogSeverity, windowOnLoadOrImmediate } from "@/shared/FunctionCore";
import HooversModal from "@/app/pages/contactProfile/HooversModal";
import Breadcrumb from "@/components/breadCrumb";
import { convertToTitleCase } from "@/utils";
import "@/app/pages/contactProfile/styles/ContactProfileHeaderStyles.scss";

type Tab = "browse" | "colleagues" | "faq" | "movers" | "overview" | "similar-contacts";

const smoothScroll = (htmlCollectionOf: HTMLCollectionOf<Element>) => {
	const firstElement = htmlCollectionOf.item(0);

	if (firstElement === null) {
		dnbComLog(LogSeverity.ERROR, "No match element was found");
	} else {
		if (htmlCollectionOf.length > 1) {
			dnbComLog(LogSeverity.ERROR, "More than one element matching element was found. Scrolling to the first one.");
		}

		firstElement.scrollIntoView({ "behavior": "smooth" });
	}
};

type ContactProfileHeaderFragmentComponentProps = ContactProfileHeaderFragmentParameter;

const ContactProfileHeader = (props: ContactProfileHeaderFragmentComponentProps): JSX.Element => {
	const { t } = useTranslation();
	const {
		contactProfileBreadcrumbFragmentComponentParameter,
		contactProfilePageData,
		colleaguesData
	} = props;

	const {
		hooversSignupPath,
		addressLocality,
		addressLocalityPath,
		addressRegion,
		addressRegionPath,
		naicsTwoPath,
		naicsTwoTitle
	} = contactProfileBreadcrumbFragmentComponentParameter;

	const {
		contact,
	} = contactProfilePageData;

	const {
		familyName,
		givenName,
		organizationName,
		title
	} = contact;

	window["___CONTACT_NAME_FOR_HOOVERS_MODAL___"] = givenName + " " + familyName;
	window["___HOOVERS_SIGNUP_PATH_FOR_HOOVERS_MODAL___"] = hooversSignupPath;

	const [activeTab, setActiveTab] = useState<Tab>("overview");
	const [previousScroll, setPreviousScroll] = useState(0);
	const [moving, setMoving] = useState<"down" | "up">("down");

	const getOnClick = (tab: Tab) => () => {
		setActiveTab(tab);

		smoothScroll(window.document.getElementsByClassName(`${tab}-block`));
	};

	const [showModal, setShowModal] = useState(false);

	const onClickModalButton = (type: "close" | "open") => setShowModal(type === "open");


	useEffect(() => {
		const $window = $(window);

		windowOnLoadOrImmediate(
			$window,
			() =>
				window.setTimeout(() => {
					// UNCOMMENT THE BELOW LINE OF CODE WHEN IMPLEMENTING ANCHORS WORK

					// if (window.document.querySelectorAll(".overview-component").length === 0) {
					// 	$("#overview").addClass("disabled-link");
					// }

					// if (window.document.querySelectorAll(".similar-contacts-component").length === 0) {
					// 	$("#similar-contacts").addClass("disabled-link");
					// }

					// if (window.document.querySelectorAll(".colleagues-component").length === 0) {
					// 	$("#colleagues").addClass("disabled-link");
					// }

					// if (window.document.querySelectorAll(".movers-component").length === 0) {
					// 	$("#movers").addClass("disabled-link");
					// }

					// if (window.document.querySelectorAll(".faq-component").length === 0) {
					// 	$("#faq").addClass("disabled-link");
					// }

					// if (window.document.querySelectorAll(".browse-component").length === 0) {
					// 	$("#browse").addClass("disabled-link");
					// }
				}, 1))
			.on("scroll", function () {
				// TODO Use $window instead?
				const $this = $(this);

				const position = $this.scrollTop() === 0 ? 0 : $this.scrollTop();

				setMoving(isNotUndefined(position) && position !== 0 && position > previousScroll ? "down" : "up");

				if (isNotUndefined(position) && position !== 0) {
					setPreviousScroll(position);
				}
			});
	}, []);

	useEffect(() => {
		if (moving === "up" && previousScroll !== 0) {
			setActiveTab("overview");
		}
	}, [previousScroll, moving]);

	const appendHtmlIfNeeded = obj => {
		if (obj.url && !obj.url.endsWith('.html')) obj.url += '.html';
		return obj;
	};
	
	let breadcrumbs = [
		{ name: t("contactDirectory.searchResultStartBreadcrumb"), url: t("homeRedirection"), useAnchorTag: true },
		{ name: t("contactDirectory.searchResultCDBreadcrumb"), url: t("contactProfilesPage") }
	];
	
	breadcrumbs = useMemo(() => {
		const dynamicBreadcrumbs = [
			{ name: naicsTwoTitle, url: naicsTwoPath },
			{ name: addressRegion, url: addressRegionPath },
			{ name: addressLocality, url: addressLocalityPath },
			{ name: givenName + " " + familyName }
		].map(appendHtmlIfNeeded);

		const dynamicBreadcrumbsNullFiltered = dynamicBreadcrumbs.filter(item => item.name);
	
		return [...breadcrumbs, ...dynamicBreadcrumbsNullFiltered];
	}, [contactProfileBreadcrumbFragmentComponentParameter]);

	const anchorsName = ["overview", "colleagues", "similar-contacts", "movers", "faq", "browse"]

	const getAnchorName = (anchor: string): string => {
		if (anchor === "faq") return "FAQ"
		if (anchor === "movers") return "Movers & Shakers"

		return convertToTitleCase(anchor)
	}

	return (
		<div className="breadcrumb-header-wrapper border-bottom-1 ">
			<div className="container-fluid header-container-wrap">
				<div className="contact-component-wrapper pb-0">

					<Breadcrumb
						breadcrumbs={breadcrumbs}
						forComponent="contactProfile"
						styling="text-capitalize font-style-medium breadcrumb-item-contact"
					/>
					<div className="container p-0">
						<div className="row">
							<div className="col-12 col-md-6">
								<h3 className="component-title name-header">
									{givenName} {familyName}
								</h3>

								<div className="title-header">
									{title}

									{" "}

									at

									{" "}

									{organizationName}
								</div>
							</div>

							<div className="col-12 col-md-6 access-btn">
								<a
									className="ContactProfileHeaderFragmentComponentGetFullAccessToGivenNameProfileLin button-primary suppress-ms-ext-icon"
									onClick={() => onClickModalButton("open")}>
									Get Full Access to
									{" "}

									{givenName}
									&apos;s Profile
								</a>
							</div>
						</div>

						<div className="row header-navbar">
							<div className="col-1 hidden-md hidden-lg tabs-arrow-wrap">
								<div className="tabs-left-arrow">
									<div className="tabs-left-arrow-icon tabs-arrow-icon" />
								</div>
							</div>

							<div className="col-10 col-md-12 tab-nav-wrapper">
								{anchorsName.map((anchor: string, index: number) => {

									if(anchor === 'colleagues' &&  !colleaguesData?.contactPeersData?.colleagues?.length ){
										return (
											<a
												key={`anchor-${index}`}
												className={classnames({
													"anchor": true,
													"plr-20": index > 0,
													"disabled-link": true
												})}
												id={anchor}	
											>
												{getAnchorName(anchor)}
											</a>)
									} else{
										return	(
									
											<a
												key={`anchor-${index}`}
												className={classnames({
													"anchor": true,
													"plr-20": index > 0,
													"active-link": activeTab === anchor
												})}
												id={anchor}
												onClick={getOnClick(anchor)}
											>
												{getAnchorName(anchor)}
											</a>)
									}
								

								})}
							</div>

							<div className="col-1 hidden-md hidden-lg tabs-arrow-wrap">
								<div className="tabs-right-arrow">
									<div className="tabs-right-arrow-icon tabs-arrow-icon" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<HooversModal
				onClickModalButton={onClickModalButton}
				showModal={showModal}
			/>
		</div>
	);
};

export default ContactProfileHeader;
